export enum PDFTemplateType {
    Default = "DEFAULT",
    Invoicing = "INVOICING",
    AdhocSalesOrder = "ADHOC_SALES_ORDER",
    AdvancedShippingNotice = "ADVANCED_SHIPPING_NOTICE",
    ShippingLabel = "SHIPPING_LABEL",
    EmployeeBenefitVoluntaryTermination = "Employee-Benefit-Voluntary-Termination",
    EmployeeBenefitInvoluntaryTermination = "EMPLOYEE_BENEFIT_INVOLUNTARY_TERMINATION"
}
